// French for TodayPage. English text is the key; a missing entry falls back to English.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Sunday': 'dimanche', 'Monday': 'lundi', 'Tuesday': 'mardi', 'Wednesday': 'mercredi',
  'Thursday': 'jeudi', 'Friday': 'vendredi', 'Saturday': 'samedi',

  'Log a touchpoint': 'Consigner un contact',
  'Review {n} →': 'Revue {n} →',
  'not collected': 'non relevé',
  'unheld proposals': 'propositions non retenues',
  'nothing waiting': 'rien en attente',

  // la ligne de détail de la cellule NON RETENU — une expression par type, singulier et pluriel
  '{n} fact': '{n} fait', '{n} facts': '{n} faits',
  '{n} affiliation': '{n} affiliation', '{n} affiliations': '{n} affiliations',
  '{n} touchpoint': '{n} contact', '{n} touchpoints': '{n} contacts',
  '{n} commitment': '{n} engagement', '{n} commitments': '{n} engagements',
  '{n} persona': '{n} persona', '{n} personas': '{n} personas',
  '{n} draft': '{n} brouillon', '{n} drafts': '{n} brouillons',
  '{n} candidate': '{n} candidat', '{n} candidates': '{n} candidats',
  '{n} signal action': '{n} action de signal', '{n} signal actions': '{n} actions de signal',
  '{n} organisation': '{n} organisation', '{n} organisations': '{n} organisations',
  '{n} person': '{n} personne', '{n} people': '{n} personnes',
  '{n} {kind}': '{n} {kind}',
  'Unheld': 'Non retenu',
  'Signals': 'Signaux',
  'no monitor runs yet · milestone M5': 'aucun moniteur n’a encore tourné · jalon M5',
  'new signals': 'nouveaux signaux',
  'Ball': 'Balle',
  'with us': 'chez nous',
  '{n} them': '{n} chez eux',
  '{who} overdue since {date}': '{who} en retard depuis le {date}',
  'Stale': 'Stagnant',
  'deals': 'affaires',
  'no deal is stale': 'aucune affaire ne stagne',
  'Cooling': 'Refroidissement',
  'people': 'personnes',
  'everyone is within cadence': 'tout le monde est dans le rythme',

  'Meetings today': 'Rendez-vous du jour',
  'No calendar feed is connected yet. This zone lists any interaction of kind meeting dated today; today has none on record.':
    'Aucun calendrier n’est encore connecté. Cette zone liste les interactions de type rendez-vous datées d’aujourd’hui; aucune n’est enregistrée aujourd’hui.',
  'with': 'avec',

  'Ball line': 'Ligne de balle',
  '{n} open': '{n} ouverte(s)',
  'who owes whom · discharge needs evidence': 'qui doit quoi à qui · solder exige une preuve',
  'No open commitments. A commitment is created from an interaction, or logged directly, and stays open until it is discharged with evidence or dropped with a reason.':
    'Aucun engagement ouvert. Un engagement naît d’une interaction ou est consigné directement, et reste ouvert jusqu’à être soldé avec preuve ou abandonné avec motif.',
  'Owner': 'À charge de',
  'Commitment': 'Engagement',
  'Counterpart': 'Contrepartie',
  'Due': 'Échéance',
  'Source': 'Source',
  'not named': 'non nommé',
  'not set': 'non défini',

  'Overnight': 'Passage de nuit',
  '22:00 – 05:30': '22h00 – 5h30',
  'Agents →': 'Agents →',
  'No night pass runs yet. From milestone M3 the inside agents triage mail, draft replies and run research overnight, and this zone reports what they read, proposed, committed and sent — always a click away from nothing sent.':
    'Aucun passage de nuit ne tourne encore. Dès le jalon M3, les agents internes trient le courrier, rédigent des réponses et font des recherches la nuit; cette zone rapporte ce qu’ils ont lu, proposé, engagé et envoyé — l’envoi reste toujours à un clic.',

  'tier cadence': 'rythme par niveau',
  'People →': 'Personnes →',
  'Nobody is past their cadence. A person cools when more days pass since the last logged interaction than their tier allows.':
    'Personne n’a dépassé son rythme. Une personne refroidit quand plus de jours se sont écoulés depuis la dernière interaction consignée que son niveau ne l’autorise.',

  // ── round 2 (§10) : la cellule SIGNAUX, Prochaines actions, la zone Signaux ──
  'no monitor exists and nothing has been raised': 'aucun moniteur et rien de relevé',

  'Next best actions': 'Prochaines actions',
  'one per person · chosen by the highest-scoring reason': 'une par personne · choisie par la raison la mieux notée',
  'People': 'Personnes',
  'Nothing has been scored yet. The rules run at 05:00 and on every interaction, signal and commitment; each action names the commitment, the signal or the cadence that produced it, with its ref and its date.':
    'Rien n’a encore été noté. Les règles tournent à 05:00 et à chaque contact, chaque signal et chaque engagement ; chaque action nomme l’engagement, le signal ou la cadence qui l’a produite, avec sa référence et sa date.',
  'Everyone was scored and nobody needs a move: no open commitment with us, no signal in thirty days, and every cadence is being kept.':
    'Tout le monde a été noté et personne ne demande de geste : aucun engagement ouvert chez nous, aucun signal depuis trente jours, et chaque cadence est tenue.',
  'no reason was recorded': 'aucune raison consignée',
  'written by {by}': 'écrit par {by}',
  'score': 'score',
  'Done': 'Fait',
  'Dismiss': 'Écarter',
  'Marked done.': 'Marqué comme fait.',
  'Dismissed. It will not be proposed again for seven days.': 'Écarté. Ce ne sera pas reproposé avant sept jours.',
  'send': 'écrire', 'call': 'appeler', 'meet': 'rencontrer',
  'research': 'documenter', 'introduce': 'faire présenter', 'wait': 'attendre',

  'every signal cites what it was read from': 'chaque signal cite ce dont il a été tiré',
  'Signals →': 'Signaux →',
  'No monitor exists and nothing has been raised. A monitor is a target with a cadence; its runs raise signals here, each citing a snapshot or a publication verbatim, with a suggested action waiting to be held.':
    'Aucun moniteur n’existe et rien n’a été relevé. Un moniteur est une cible avec une cadence ; ses passages font remonter ici des signaux, chacun citant mot pour mot un instantané ou une publication, avec une action suggérée en attente d’être retenue.',
  'The monitors ran and raised nothing new. That is a counted zero, not an absence of watching.':
    'Les moniteurs ont tourné et n’ont rien relevé de nouveau. C’est un zéro compté, pas une absence de veille.',
  'risk': 'risque', 'budget': 'budget', 'board': 'conseil', 'move': 'mouvement',
  'post': 'publication', 'tender': 'appel d’offres', 'mention': 'mention', 'coverage': 'couverture',
  'info': 'info', 'attend': 'à suivre', 'high': 'élevé',


  'Date not confirmed': 'Date non confirmée',
  'Kind': 'Type',
  'Date': 'Date',
  'Title': 'Titre',
  'What happened, in a few words': 'Ce qui s’est passé, en quelques mots',
  'Summary': 'Résumé',
  'Organisation': 'Organisation',
  'Search organisations': 'Rechercher des organisations',
  'Participants': 'Participants',
  'Search people, or type a name and add it': 'Rechercher des personnes, ou saisir un nom et l’ajouter',
  'Add "{name}" as a name, not yet a person': 'Ajouter « {name} » comme nom, pas encore une personne',
  'Touchpoint logged.': 'Contact consigné.',
  'Could not save the touchpoint.': 'Impossible d’enregistrer le contact.',
  'Nothing logged here yet. A meeting, a call, a mail, a note — every touchpoint with provenance becomes a row.':
    'Rien n’est encore consigné ici. Un rendez-vous, un appel, un courriel, une note — chaque contact avec sa provenance devient une ligne.',
  'Mail in': 'Courriel entrant', 'Mail out': 'Courriel sortant', 'Meeting': 'Rendez-vous', 'Call': 'Appel',
  'Note': 'Note', 'Post': 'Publication', 'Signal': 'Signal',

  // ── overnight · the runs of the last day (R3f) ──
  'The runtime has not reported. Nothing is claimed about the night either way.': 'Le moteur d’exécution n’a rien annoncé. Rien n’est affirmé sur la nuit, dans un sens comme dans l’autre.',
  'No run in the last day. The inside agents triage mail, draft replies and read pages overnight; each one appears here with its ref, and the ref opens the desk that shows what it did.': 'Aucune passe depuis un jour. Les agents internes trient le courrier, rédigent des réponses et lisent des pages la nuit ; chacune paraît ici avec sa référence, et la référence ouvre le poste qui montre ce qu’elle a fait.',
  'Open this run’s desk': 'Ouvrir le poste de cette passe',
  'filed': 'déposées',
}, 'TodayPage');
